function Home() {
  return (
    <div className="bg-slate-950 text-white">
      <header className="mx-auto flex max-w-3xl flex-col items-center justify-center gap-4 px-6 py-16 text-center">
        <img
          src="/flagfinder-jobcard-light.svg"
          className="h-20 w-auto"
          alt="JobCards logo"
        />
        <h1 className="text-3xl font-semibold tracking-tight">
          JobCards keeps field work organized.
        </h1>
        <p className="text-base text-slate-300">
          Plan callouts, capture updates, and turn work into clean, shareable
          records.
        </p>
      </header>
    </div>
  )
}

export default Home
